export default "__VITE_ASSET__DSJnXpI5__"